import React , { Component } from 'react'

import PropTypes from 'prop-types'

import moment from 'moment/moment'

import format   from 'vegas-js-core/src/strings/fastformat'
import isString from 'vegas-js-core/src/isString'
import ucFirst  from 'vegas-js-core/src/strings/ucFirst'

import initApp from '../../../contexts/app/initApp'

import LabelItem from '../../../components/items/LabelItem'

import visibilityMode, { visibilityModes } from '../../../styles/modes/visibilityMode'

class Death extends Component
{
    getLocale = () => this.props.locale.things.person.death ;
    
    render()
    {
        const { visibility } = this.props ;
        
        if( visibility === visibilityMode.NONE )
        {
            return null ;
        }
        
        const { icon, person } = this.props ;
        
        const locale = this.getLocale() ;
        
        const {
            date,
            pattern,
            place,
            separator,
            title,
            empty
        } = locale ;
        
        let label = null ;
        
        if( person )
        {
            const {deathDate , deathPlace } = person ;
            
            if( deathDate || deathPlace )
            {
                label = [] ;
                if( isString(deathDate) && (deathDate !== '') )
                {
                    label.push( format(date, moment(deathDate).format(pattern)) )  ;
                }

                if( isString(deathPlace) && (deathPlace !== '') )
                {
                    label.push( format(place,deathPlace) ) ;
                }
                
                if( label.length > 0 )
                {
                    label = ucFirst(label.join( separator )) ;
                }
                else
                {
                    label = null ;
                }
            }
        }
        
        const isEmpty = !(isString(label) && (label !== '')) ;
        
        if( visibility === visibility.AUTO && isEmpty )
        {
            return null ;
        }
        
        if( isEmpty && isString(empty) )
        {
            label = empty ;
        }
        
        return <LabelItem icon={icon} title={title}>{label}</LabelItem> ;
    }
}

Death.defaultProps =
{
    icon       : null, //  <FaSkull size="1em"/>,
    person     : null ,
    style      : null ,
    visibility : visibilityMode.NORMAL
};

Death.propTypes =
{
    icon       : PropTypes.element,
    locale     : PropTypes.object,
    person     : PropTypes.object,
    style      : PropTypes.oneOfType([PropTypes.object, PropTypes.array]) ,
    visibility : PropTypes.oneOf(visibilityModes)
};

export default initApp(Death) ;